// action enums
import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';

export enum ActionsEnum {
  AUTHENTICATED = 'AUTHENTICATED',
  AUTHENTICATED_THROUGH_BILLING = 'AUTHENTICATED_THROUGH_BILLING',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  UPDATE_ACCOUNT_ID = 'UPDATE_ACCOUNT_ID',
  UPDATE_USER_ID = 'UPDATE_USER_ID',
  LOGIN = 'LOGIN',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_ERROR = 'LOGIN_ERROR',
  LOGOUT = 'LOGOUT',
  SET_REDIRECT_PATH = 'SET_REDIRECT_PATH',
  UPDATE_TOKENS = 'UPDATE_TOKENS',
}

// action payload interfaces
export interface IIsForced {
  isForced: boolean;
}

export interface IAccountId {
  accountId: string;
}

export interface IUserId {
  userId: string;
}

export interface IUnauthenticated extends IIsForced, IAccountId, IUserId {}

export interface ILogin extends IDispatchId {
  username: string;
  pw: string;
  accountId: string;
}

export interface ISetRedirectPath {
  redirectPath: string;
}

export interface IUpdateTokens {
  accessToken: string;
  refreshToken: string;
}

export interface ILogout extends IIsForced, ISetRedirectPath {}

// action definitions
export interface Authenticated {
  type: ActionsEnum.AUTHENTICATED;
}

export interface AuthenticatedThroughBilling {
  type: ActionsEnum.AUTHENTICATED_THROUGH_BILLING;
}

export interface Unauthenticated {
  type: ActionsEnum.UNAUTHENTICATED;
  payload: IUnauthenticated;
}

export interface UpdateAccountId {
  type: ActionsEnum.UPDATE_ACCOUNT_ID;
  payload: IAccountId;
}

export interface UpdateUserId {
  type: ActionsEnum.UPDATE_USER_ID;
  payload: IUserId;
}

export interface Login {
  type: ActionsEnum.LOGIN;
  payload: ILogin;
}

export interface LoginSuccess {
  type: ActionsEnum.LOGIN_SUCCESS;
  payload: IDispatchId;
}

export interface LoginError {
  type: ActionsEnum.LOGIN_ERROR;
  payload: IRequestError;
}

export interface Logout {
  type: ActionsEnum.LOGOUT;
  payload: ILogout;
}

export interface SetRedirectPath {
  type: ActionsEnum.SET_REDIRECT_PATH;
  payload: ISetRedirectPath;
}

export interface UpdateTokens {
  type: ActionsEnum.UPDATE_TOKENS;
  payload: IUpdateTokens;
}

// action creators
export const authenticated = (): Authenticated => ({
  type: ActionsEnum.AUTHENTICATED,
});

export const authenticatedThroughBilling = (): AuthenticatedThroughBilling => ({
  type: ActionsEnum.AUTHENTICATED_THROUGH_BILLING,
});

export const unauthenticated = (
  userId: string,
  accountId: string,
  isForced: boolean
): Unauthenticated => ({
  type: ActionsEnum.UNAUTHENTICATED,
  payload: {
    userId,
    accountId,
    isForced,
  },
});

export const updateAccountId = (accountId: string): UpdateAccountId => ({
  type: ActionsEnum.UPDATE_ACCOUNT_ID,
  payload: {
    accountId,
  },
});

export const updateUserId = (userId: string): UpdateUserId => ({
  type: ActionsEnum.UPDATE_USER_ID,
  payload: {
    userId,
  },
});

export const login = (
  dispatchId: string,
  username: string,
  pw: string,
  accountId?: string
): Login => ({
  type: ActionsEnum.LOGIN,
  payload: {
    dispatchId,
    username,
    pw,
    accountId,
  },
});

export const loginSuccess = (dispatchId: string): LoginSuccess => ({
  type: ActionsEnum.LOGIN_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const loginError = (dispatchId: string, error: Error): LoginError => ({
  type: ActionsEnum.LOGIN_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const logout = (
  isForced: boolean = false,
  redirectPath: string = null
): Logout => ({
  type: ActionsEnum.LOGOUT,
  payload: {
    isForced,
    redirectPath,
  },
});

export const setRedirectPath = (redirectPath: string): SetRedirectPath => ({
  type: ActionsEnum.SET_REDIRECT_PATH,
  payload: {
    redirectPath,
  },
});

export const updateTokens = (
  accessToken: string,
  refreshToken: string
): UpdateTokens => ({
  type: ActionsEnum.UPDATE_TOKENS,
  payload: {
    accessToken,
    refreshToken,
  },
});
